(function () {
    let isShowH5ChildNav = true;
    const uniqueToolsMenus = document.getElementsByClassName('unique-tool-menu');
    const tooltips = document.getElementsByClassName('unique-tooltip');

    const imgDoms = document.getElementsByClassName('downOrUpIcon')

    for (let i = 0; i < uniqueToolsMenus.length; i++) {
        uniqueToolsMenus[i].addEventListener('mouseover', () => {
            tooltips[i].classList.add('unique-tooltip-appear');
            imgDoms[i].src = 'https://vidfly-02.oss-us-east-1.aliyuncs.com/blog/images/upArrow.svg';
        })
        uniqueToolsMenus[i].addEventListener('mouseleave', () => {
            tooltips[i].classList.remove('unique-tooltip-appear')
            imgDoms[i].src = 'https://vidfly-02.oss-us-east-1.aliyuncs.com/blog/images/down.svg';
        })
    }

    // h5的菜单点击事件
    const h5Menu = document.getElementById('unique-h5-menu');
    // h5导航弹窗dom
    const h5Navgation = document.getElementById('unique-h5-navgation');

    h5Menu.addEventListener('click', () => {
        h5Navgation.classList.add('unique-h5-navgation-active')
    })

    // 弹窗关闭按钮点击事件
    const h5CloseBtn = document.getElementById('unique-h5-nav-btn');
    h5CloseBtn.addEventListener('click', () => {
        h5Navgation.classList.remove('unique-h5-navgation-active')
    })

    // h5下拉菜单导航点击事件
    const h5Navs = document.getElementsByClassName('unique-h5-nav-title');
    const h5ChildNavs = document.getElementsByClassName('unique-h5-child-nav');
    for (let i = 0; i < h5Navs.length; i++) {
        let isShowH5ChildNav = true;
        h5Navs[i].addEventListener('click', () => {
            if (isShowH5ChildNav) {
                // 展开子导航菜单
                h5ChildNavs[i].classList.add('unique-h5-child-nav-deactive')
            } else {
                h5ChildNavs[i].classList.remove('unique-h5-child-nav-deactive')
            }
            isShowH5ChildNav = !isShowH5ChildNav
        })
    }
})();